import React from 'react';
const RequiredAsterisk = () => {
    return React.createElement("span", { className: "text-red-500 text-[12px]" }, "*");
};
export default RequiredAsterisk;
